"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_STORAGE_NAMES = exports.useLocalStorage = exports.clear = exports.remove = exports.getObject = exports.get = exports.setObject = exports.set = void 0;
function set(key, value) {
    return localStorage.setItem(key, value);
}
exports.set = set;
function setObject(key, object) {
    return localStorage.setItem(key, JSON.stringify(object));
}
exports.setObject = setObject;
function get(key) {
    var value = localStorage.getItem(key);
    return value === "undefined" ? undefined : value;
}
exports.get = get;
function getObject(key) {
    var value = localStorage.getItem(key);
    try {
        return value ? JSON.parse(value) : undefined;
    }
    catch (error) {
        return {};
    }
}
exports.getObject = getObject;
function remove(key) {
    return localStorage.removeItem(key);
}
exports.remove = remove;
function clear() {
    return localStorage.clear();
}
exports.clear = clear;
function useLocalStorage() {
    return {
        set: set,
        setObject: setObject,
        get: get,
        getObject: getObject,
        remove: remove,
        clear: clear,
    };
}
exports.useLocalStorage = useLocalStorage;
var storage = {
    set: set,
    setObject: setObject,
    get: get,
    getObject: getObject,
    remove: remove,
    clear: clear,
};
exports.DEFAULT_STORAGE_NAMES = {
    TOKEN: "token",
    SETTINGS: "settings",
};
exports.default = storage;
